import type { IApiResponse } from 'v2/interfaces/api';

import { apiServiceProxy } from './api-proxy';

type CampaignAcceptance = {
  productId: number;
  offerId: number;
  offerValue: number;
  promotionId: number;
};

function dataOf<T>(response: IApiResponse<T> | null | undefined, fallback: T): T {
  return response?.data ?? fallback;
}

export const highTicketCampaignClient = {
  listEligiblePromotions(offerValue: number) {
    return apiServiceProxy
      .get<unknown[]>('/products/high-ticket-campaign', { offerValue })
      .then(response => dataOf(response, []));
  },
  listActivePromotions(productId: number, offerId: number) {
    return apiServiceProxy
      .get<unknown[]>('/products/high-ticket-campaign/active', { productId, offerId })
      .then(response => dataOf(response, []));
  },
  removeCampaignOption(promotionId: number, offerId: number): Promise<void> {
    return apiServiceProxy
      .delete<void>(`/products/high-ticket-campaign/${promotionId}/offers/${offerId}`)
      .then((): void => undefined);
  },
  registerCampaignOption(input: CampaignAcceptance): Promise<void> {
    return apiServiceProxy.post<void>('/products/high-ticket-campaign', input).then((): void => undefined);
  },
  acceptCampaignTerms(input: CampaignAcceptance): Promise<void> {
    return apiServiceProxy
      .post<void>(`/products/${input.productId}/high-ticket-campaign/terms`, {
        offerId: input.offerId,
        offerValue: input.offerValue,
        promotionId: input.promotionId
      })
      .then((): void => undefined);
  }
};
